import React, { useState } from "react";
import { CFormText } from "@coreui/react";
import { useDispatch } from "react-redux";
import { createPreset, reset } from "../redux/locationsSelectorSagas";
import { MainModal } from "../../../components/modal/MainModal";
import { useError } from "../hooks/useError";

export const CreatePreset = ({ isOpen, onClose, type }) => {
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const close = (e) => {
    e && e.preventDefault();

    dispatch(reset());
    setName("");
    setLoading(false);
    onClose();
  };

  const { errors } = useError(close);

  const save = (e) => {
    setLoading(true);
    e.preventDefault();
    dispatch(createPreset({ name: name.trim(), type }));
  };

  const onChange = (e) => {
    if (e.target.value.length <= 32) {
      setName(e.target.value);
    }
  };

  return (
    <MainModal
      uiLoader={loading}
      parentSelector=".location-selector"
      isOpen={isOpen}
      onClose={close}
      headerText="Give it a name"
      headerCloseHandler={close}
      height="auto"
      width={480}
      primaryButtonText="Save"
      primaryBtnHandler={save}
      primaryButtonDisabled={!name}
      secondaryBtnText="Cancel"
      secondaryBtnHandler={close}
    >
      <div className="location-selector__modal">
        <p className="title">Preset name</p>
        <input type="text" value={name} onChange={onChange} className="location-selector__input" />
        {errors && <CFormText className="help-block">* {errors}</CFormText>}
      </div>
    </MainModal>
  );
};
